module.exports = "<div style=\"height: 100%; width: 100%\">\n\n</div>\n"